export default "__VITE_ASSET__CWDm3A$m__"